import { useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Confirm } from '../forms/Confirm';
import Textarea from '../forms/Textarea';
import Button from '../ui/Button';
import Modal from '../ui/Modal';

type RejectLeadForm = {
  comment: string;
};

type RejectLeadProps = {
  open: boolean;
  onReject: SubmitHandler<RejectLeadForm>;
  setOpen: (boolean) => void;
};

const RejectLead = ({ open, onReject, setOpen }: RejectLeadProps) => {
  const { register, handleSubmit } = useForm<RejectLeadForm>();
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [block, setBlock] = useState(false);

  const handleOnConfirm = () => {
    setBlock(false);
    setShowConfirmation(false);
    handleSubmit(onReject)();
  };

  const handleOnCancel = () => {
    setBlock(false);
    setShowConfirmation(false);
  };

  return (
    <Modal open={open} setOpen={setOpen} block={block}>
      <Confirm
        title="Are you sure you want to reject the lead?"
        open={showConfirmation}
        onConfirm={handleOnConfirm}
        onCancel={handleOnCancel}
        setOpen={(open) => {
          setShowConfirmation(open);
          setBlock(open);
        }}
      />
      <form name="rejectLeadForm" className="flex flex-col">
        <label className="font-bold mb-2">Comment: </label>
        <Textarea
          name="comment"
          register={register}
          options={{ required: true }}
          cols={30}
          rows={5}
          className="mb-2"
        />
      </form>
      <Button
        text="Reject"
        color="red"
        className="w-full"
        onClick={() => {
          setBlock(true);
          setShowConfirmation(true);
        }}
      />
    </Modal>
  );
};

export default RejectLead;
